import React from 'react';
import { ContentCenter } from './ContentCenter';

import { LibraryType } from './ContentCenter.types';

export const DataVisualizationLibrary: React.FC = () => (
  <ContentCenter libraryType={'dataVisualizationLibrary' as LibraryType} />
);
